import React from 'react';
import { Box, Typography, Stack, Divider } from '@mui/material';

const AdtInfoWindow = (props) => {
    const feature = props.feature;
    if (!feature) return null;

    // Clean street name by replacing (), <> with spaces
    const cleanStreetName = (name) => {
        if (!name) return null;
        return name.replace(/[()<>]/g, ' ').replace(/\s+/g, ' ').trim();
    };

    // Convert direction abbreviation to full word
    const getFullDirection = (dir) => {
        if (!dir) return null;
        const dirMap = {
            'N': 'North',
            'S': 'South',
            'E': 'East',
            'W': 'West',
            'NE': 'Northeast',
            'NW': 'Northwest',
            'SE': 'Southeast',
            'SW': 'Southwest',
            'NB': 'Northbound',
            'SB': 'Southbound',
            'EB': 'Eastbound',
            'WB': 'Westbound'
        };
        return dirMap[dir.toUpperCase()] || dir;
    };

    return (
        <Box className="map-popup-text" sx={{ maxWidth: 300 }}>
            <Stack spacing={1}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        Average Daily Traffic
                    </Typography>
                </Box>
                {feature.street_name &&
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {cleanStreetName(feature.street_name)}
                    </Typography>
                }
                <Stack spacing={0.5}>
                    {feature.direction &&
                        <Typography variant="body2">
                            • Direction: {getFullDirection(feature.direction)}
                        </Typography>
                    }
                    {feature.adt_all_sources != null &&
                        <Typography variant="body2">
                            • ADT Count: <strong>{Number(feature.adt_all_sources).toLocaleString()}</strong>
                        </Typography>
                    }
                </Stack>
                {feature.adt_modified &&
                    <>
                        <Divider />
                        <Typography variant="caption">
                            Updated: {new Date(feature.adt_modified).toLocaleString()}
                        </Typography>
                    </>
                }
            </Stack>
        </Box>
    );
};

export { AdtInfoWindow };

export default  {
    name: "Average Daily Traffic Counts",
    mapLayerIcon: "",
    defaultOn: false,
    showOnMap: true,
    wmsMapLayer: "cdot:congestionadt",
    wmsPublish: "tasWebapp.congestion.segments.publishing",
    wmsClickable: true
}